export default {"src":"/_next/static/media/icon-primary-check.c0fd8275.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};